import { Col, Container, Image, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player/lazy';


export default function Header({links}) {
  const [title1, setTitle1] = useState(true);
  const [title2, setTitle2] = useState(false);
  const [title3, setTitle3] = useState(false);

  const [video1, setVideo1] = useState(true);
  const [video2, setVideo2] = useState(false);
  const [video3, setVideo3] = useState(false);

  const title1Handler = () => { setTitle1(true); setTitle2(false); setTitle3(false); };
  const title2Handler = () => { setTitle1(false); setTitle2(true); setTitle3(false); };
  const title3Handler = () => { setTitle1(false); setTitle2(false); setTitle3(true); };

  const video1Handler = () => { setVideo1(true); setVideo2(false); setVideo3(false); };
  const video2Handler = () => { setVideo1(false); setVideo2(true); setVideo3(false); };
  const video3Handler = () => { setVideo1(false); setVideo2(false); setVideo3(true); };

  return (
    <>
    <Container fluid id="header-wrapper">
      <Row className="text-center" >
        <Col lg={3} xl={3} className="ml-auto header-d"></Col>
        <Col sm={12} lg={2} xl={2}>
          {/* <a href='https://www.swmc.com/'
            target="_blank" rel="noreferrer noopener"
            title="https://www.swmc.com/">
            <Image
              src="https://stagingresources.swmc.com/swmc-images/Chris-Pavan/cp-sunwest-logo-tp.png"
              fluid
              alt="Sun West Mortgage Logo"
              className="mt-5 mb-3 sunwest-logo"
            />
          </a> */}
        </Col>
      </Row>
      <Row>
        <Col>
        <div className='desktopangel'>
        <div className='angelalerttop'>
        Angel Alert!
        </div>
        <div className='angelalert'>
       
        <div className='bigupgrade'>
        Big upgrades since this podcast aired. Underwriting and Condition Review is now
        </div>
        <div className='ondemand'>
        ON DEMAND.
        </div>
        <div className='improving'>
        <a className='imgspan' href='https://angelai.com/' target='_blank'>AngelAi</a> is continuously improving and getting faster!
        </div>
        </div>
        </div>
        </Col>
      </Row>
      <Row>
       
        <Col lg={3} xl={3} className="ml-auto"></Col>
        <Col md={12} lg={3} xl={3} className="mt-5 mb-3">
          <div className="pt-3 mb-3 pageInfoHighlightsContainer">
            <h4 className="pageInfoHeading d-none d-lg-block d-xl-block ps-2">
              An incredibly valuable <br /> chat session on <br /> Chris Johnstone's podcast, <br /> The Loan Officer Wealth.
            </h4>

            <h4 className="pageInfoHeading2 d-lg-none d-xl-none d-sm-block d-xs-block text-center">
            An incredibly valuable chat session on Chris Johnstone's podcast, The Loan Officer Wealth.
            </h4>
            {/* <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES_CP}cp-blue-bar.png`} width="" height="120px" className="orange-bar" /> */}
          </div>
          <p className="pageInfotext d-none d-lg-block d-xl-block">As a guest, Pavan Agarwal, the CEO of
            Sun West Mortgage Company Inc., reveals how {links.current.brandName}, Sun West's super Ai, is transforming the
            mortgage market by increasing the loan processing speed and decreasing the loan officer stress.</p>
          <p className="pageInfotext text-center d-lg-none d-xl-none d-sm-block d-xs-block">
            As a guest, Pavan Agarwal, the CEO of
            Sun West Mortgage Company Inc., reveals how {links.current.brandName}, Sun West's super Ai, is transforming the
            mortgage market by increasing the loan processing speed and decreasing the loan officer stress.</p>


          <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES_CP}cp-star-blue.png`} width="45px" height="45px" className="star-vector-01" />
        </Col>
        <div className='continuesdiv'>
        <div className='angelalerttop'>
        Angel Alert!
        </div>
        <div className='angelalert'>
       
        <div className='bigupgrade'>
        Big upgrades since this podcast aired. Underwriting and Condition Review is now
        </div>
        <div className='ondemand'>
        ON DEMAND.
        </div>
        <div className='improving'>
        <a className='imgspan' href='https://angelai.com/' target='_blank'>AngelAi</a> is continuously improving and getting faster!
        </div>
        </div>
        </div>

        <Col md={12} lg={4} xl={4} style={{ marginTop: "", zIndex: "3" }}>
          <div id="main-player" className="player-wrapper">
            <ReactPlayer
              className="react-player"
              url="https://youtu.be/zmsrdyPUJHM"
              width="100%" height="100%"
              light={`${process.env.REACT_APP_CDN_IMAGES_CP}cp-carousel-001.webp`}
              playing con controls
              onClick={video1Handler}
            />
          </div>
          <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES_CP}cp-star-white.png`} width="60px" height="60x" className="star-vector-02" />

          {/* <div className="waveWhite">
            <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES_CP}cp-wave-right.png`} width="220px" height="" className="ta-podcast-wave-white" /></div> */}
        </Col>
        <div><Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES_CP}cp-grid-white.png`} width="" height="90px" className="grid-white" /></div>
        <Row className="row2" style={{ marginTop: "-9rem", zIndex: "2" }}>
          <Col lg={2} xl={2} sm={0} xs={0} className="cl-1 ml-auto d-lg-block d-xl-block"></Col>

          <Col md={6} sm={4} xs={4} lg={2} className="mx-lg-3 mx-xl-3 mt-3" >
            <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES_CP}cp-star-blue.png`} width="38px" height="38px" className="star-vector-03" />
            <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES_CP}cp-star-white.png`} width="38px" height="38px" className="star-vector-04" />

          </Col>
        </Row>
      </Row>
    </Container>
    <div className="waveWhitemobile">
    <div className='imageofredios'>
            <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES_CP}cp-wave-right.png`} width="220px" height="" className="" /></div> 
            <div>
            <p className='weraetext'>
            We are here to assist you.<br></br>
For questions or to learn more, start here:
            </p>
            </div>
           
    </div>
    </>
  );
}
